import { Link } from "react-router-dom";
import useDepartmentDoctors from "../hooks/useDepartmentDoctors";
import DoctorCard from "./DoctorCard";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { Phone, Mail, MapPin, CheckCircle2, Users, Award, Clock, Heart, Shield } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import SEO from "../pages/SEO"
import { useAppointment } from "../context/AppointmentContext"
export default function DentalPage() {
  const { open: openAppointment } = useAppointment();
  const doctors = [];


  const subspecialties = [
    {
      title: "General Dentistry",
      description: "Cleaning, fillings, extractions & preventive oral care.",
      image: "/GeneralDentistry.jpg",
    },
    {
      title: "Cosmetic Dentistry",
      description: "Smile design, teeth whitening & veneers.",
      image: "/CosmeticDentistry.jpg",
    },
    {
      title: "Orthodontics",
      description: "Braces, aligners & bite correction.",
      image: "/Orthodontics.jpg",
    },
    {
      title: "Pedodontics (Child Dentistry)",
      description: "Dental care for children & teens.",
      image: "/Pedodontics(Child Dentistry).jpg",
    },
    {
      title: "Endodontics",
      description: "Root canal treatment & dental restorations.",
      image: "/Endodontics.jpg",
    },
    {
      title: "Periodontics",
      description: "Gum disease treatment & oral hygiene care.",
      image: "/Periodontics.jpg",
    },
    {
      title: "Prosthodontics",
      description: "Crowns, bridges, dentures & implants.",
      image: "/Prosthodontics.jpg",
    },
    {
      title: "Oral & Maxillofacial Surgery",
      description: "Wisdom tooth removal, jaw surgeries & trauma care.",
      image: "/Oral&MaxillofacialSurgery.jpg",
    },
  ];

  const treatments = [
    "Routine Dental Checkups & Cleaning",
    "Fillings & Dental Restorations",
    "Root Canal Treatment (RCT)",
    "Braces, Ceramic Brackets & Clear Aligners",
    "Teeth Whitening & Cosmetic Smile Makeovers",
    "Dental Implants & Full Mouth Rehabilitation",
    "Gum Treatment & Deep Cleaning (Scaling/Root Planing)",
    "Pediatric Dental Treatments",
    "Wisdom Tooth Extraction",
    "Crowns, Bridges & Dentures",
  ];

  const whyChoose = [
    { icon: Users, title: "Expert Dental Team", description: "Experienced dentists & multi-specialty dental team" },
    { icon: Award, title: "Modern Equipment", description: "Modern dental equipment & painless treatment techniques" },
    { icon: Shield, title: "Safe Environment", description: "Infection-controlled & safe dental environment" },
    { icon: Heart, title: "Family Dentistry", description: "Complete family dentistry under one roof" },
    { icon: Clock, title: "Affordable Plans", description: "Affordable and patient-friendly treatment plans" },
  ];

  const articles = [
    {
      title: "Top Tips for Maintaining Healthy Teeth & Gums",
      excerpt: "Discover essential daily habits and professional care tips to maintain optimal oral health for life.",
    },
    {
      title: "Is Teeth Whitening Safe? What You Should Know",
      excerpt: "Learn about modern teeth whitening procedures, safety considerations, and expected results.",
    },
    {
      title: "When Do You Need a Root Canal Treatment?",
      excerpt: "Understanding the signs, symptoms, and treatment process for root canal therapy.",
    },
    {
      title: "Dental Care Tips for Children & Teenagers",
      excerpt: "Essential guidance for parents on maintaining their children's dental health from infancy to adolescence.",
    },
  ];

  const faqs = [
    {
      question: "Do you treat children's dental problems?",
      answer:
        "Yes, we have specialist pediatric dentists for safe and friendly child dental care. Our child-friendly approach ensures a comfortable experience for young patients, helping them develop positive attitudes toward dental health.",
    },
    {
      question: "Are dental procedures painful?",
      answer:
        "No, most procedures are performed using painless or minimally painful techniques. We use modern anesthesia and sedation methods to ensure patient comfort throughout all treatments.",
    },
    {
      question: "Do you provide braces and aligners?",
      answer:
        "Yes, we offer metal braces, ceramic braces, and clear aligners for teeth straightening. Our orthodontic team will evaluate your case and recommend the best option based on your needs and preferences.",
    },
  ];
  const schema = [
  {
    "@context": "https://schema.org",
    "@type": "Dentist",
    "name": "MAMS Hospitals Dental Department",
    "url": "https://mamshospitals.com/dental",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "image": "https://mamshospitals.com/Dental.jpg",
    "description": "MAMS Hospitals provides advanced dental treatments in Hyderabad including cosmetic dentistry, root canal treatment, braces, aligners, dental implants, pediatric dentistry, and oral surgery.",
    "telephone": "+91-7399999981",
    "priceRange": "$$",

    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },

    "availableService": [
      {
        "@type": "MedicalProcedure",
        "name": "Root Canal Treatment"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Dental Implants"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Braces & Clear Aligners"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Teeth Whitening & Smile Makeover"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Wisdom Tooth Extraction"
      }
    ],

    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do you provide braces and aligners?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals offers metal braces, ceramic braces, and clear aligners for teeth straightening and smile correction."
        }
      },
      {
        "@type": "Question",
        "name": "Is root canal treatment painful?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No, modern root canal treatment is usually painless with advanced anesthesia and dental techniques."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide dental care for children?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals provides pediatric dental care including preventive dentistry, fillings, and orthodontic evaluation for children."
        }
      }
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Dental Department - MAMS Hospitals",
    "url": "https://mamshospitals.com/dental",
    "description": "Best dental hospital in Hyderabad offering root canal treatment, dental implants, braces, aligners, cosmetic dentistry, pediatric dentistry, and smile makeovers.",
    "keywords": [
      "Best Dentist Hyderabad",
      "Dental Hospital Hyderabad",
      "Root Canal Treatment Hyderabad",
      "Dental Implants Hyderabad",
      "Braces Treatment Hyderabad",
      "Cosmetic Dentistry Hyderabad",
      "Dental Hospital Bachupally"
    ]
  }
];

  return (
    <>
  <SEO
    title="Best Dental Hospital in Hyderabad | Dentists & Smile Care | MAMS Hospitals"
    description="MAMS Hospitals offers advanced dental treatments in Hyderabad including root canal treatment, braces, aligners, cosmetic dentistry, dental implants, pediatric dentistry, and smile makeovers."
    keywords="best dentist Hyderabad,
dental hospital Hyderabad,
root canal treatment Hyderabad,
dental implants Hyderabad,
braces treatment Hyderabad,
clear aligners Hyderabad,
cosmetic dentistry Hyderabad,
teeth whitening Hyderabad,
wisdom tooth extraction Hyderabad,
pediatric dentist Hyderabad,
smile makeover Hyderabad,
dental hospital Bachupally,
MAMS Hospitals Dental"
    schema={schema}
  />
    <div className="flex flex-col min-h-screen">

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-50 via-white to-blue-50 py-12 md:py-24">
        <div className="container mx-auto px-0 max-w-6xl">

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">

            <div>
              <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                Best Dental Hospital in Hyderabad
              </div>

              <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">Healthy Teeth, Confident Smile</h1>

              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                MAMS Hospitals is recognized as one of the Best Dental Hospitals in Hyderabad, offering complete oral
                care ranging from routine dental checkups to advanced cosmetic and restorative treatments.
              </p>

             <div className="flex flex-col sm:flex-row gap-4">

                <Button className="bg-teal-600 hover:bg-teal-700 text-white rounded-full px-8" size="lg" onClick={openAppointment}>
                    Book Appointment
                  </Button>

                <Link to="tel:+91-7399999981">
                  <Button
                    className="border-teal-600 text-teal-600 hover:bg-teal-50 rounded-full px-8"
                    variant="outline"
                    size="lg"
                  >
                    <Phone className="mr-2 h-5 w-5" />
                    Call Us
                  </Button>
                </Link>

              </div>
            </div>

            <div className="relative">
              <div className="absolute -top-4 -right-4 bg-teal-600 text-white p-6 rounded-2xl shadow-xl z-10">
                <div className="text-3xl font-bold">100%</div>
                <div className="text-sm">Patient Satisfaction</div>
              </div>

              <img
                src="/Dental.jpg"
                alt="Dental Care at MAMS Hospital"
                className="rounded-2xl shadow-2xl w-full"
              canonicalUrl="https://mamshospitals.com/departments/dental"
      />
            </div>

          </div>

        </div>
      </section>

      {/* Sub-Specialties */}
      <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-0 max-w-6xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Sub-Specialities in Dentistry</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">Comprehensive dental expertise across multiple specializations</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {subspecialties.map((specialty, index) => (
              <Card key={index} className="group hover:shadow-xl transition-all duration-300 border-gray-200 hover:border-teal-500">
                <CardContent className="p-0">

                  <div className="relative h-48 overflow-hidden rounded-t-lg">
                    <img
                      src={specialty.image || "/placeholder.svg"}
                      alt={specialty.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>

                  <div className="p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">{specialty.title}</h3>
                    <p className="text-gray-600 leading-relaxed text-sm">{specialty.description}</p>
                  </div>

                </CardContent>
              </Card>
            ))}
          </div>

        </div>
      </section>

      {/* Treatments */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-0 max-w-6xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Treatments & Procedures</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">Advanced dental procedures performed with precision and care</p>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            {treatments.map((treatment, index) => (
              <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm">
                <CheckCircle2 className="h-6 w-6 text-teal-600 flex-shrink-0 mt-1" />
                <span className="text-gray-700 font-medium">{treatment}</span>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* Why Choose */}
      <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-0 max-w-6xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Why Choose MAMS Hospitals for Dental Care</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">Trusted dental excellence with patient-centered care</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">

            {whyChoose.map((item, index) => {
              const Icon = item.icon;
              return (
                <Card key={index} className="border-gray-200 hover:shadow-lg transition-shadow">
                  <CardContent className="p-6">

                    <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-4">
                      <Icon className="h-7 w-7 text-teal-600" />
                    </div>

                    <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{item.description}</p>

                  </CardContent>
                </Card>
              );
            })}

          </div>

        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 md:py-20 bg-gray-50">
        <div className="container mx-auto px-0 max-w-4xl">

          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
            <p className="text-lg text-gray-600">Get answers to common questions about dental care</p>
          </div>

          <Accordion type="single" collapsible className="bg-white rounded-lg shadow-sm">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>

                <AccordionTrigger className="text-left px-6 hover:text-teal-600">
                  {faq.question}
                </AccordionTrigger>

                <AccordionContent className="px-6 text-gray-600 leading-relaxed">
                  {faq.answer}
                </AccordionContent>

              </AccordionItem>
            ))}
          </Accordion>

        </div>
      </section>

      {/* Contact & Appointment Section */}
      <section className="py-16 px-0 bg-apple-teal text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold mb-4">Book an Appointment</h2>
            <p className="text-white/90 max-w-2xl mx-auto">
              Your heart health is our top priority. Book an appointment today with Hyderabad's trusted experts at MAMS Hospitals
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Phone className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Call Us</h3>
                <a href="tel:+917399999981" className="text-white/90 hover:text-white">
                  +91-7399999981
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Mail className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Email Us</h3>
                <a href="mailto: info@mamshospitals.com" className="text-white/90 hover:text-white">
                   info@mamshospitals.com
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <MapPin className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Visit Us</h3>
                <p className="text-white/90">Bachupally, Miyapur</p>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            {/* <Link href="/book-appointment">
              <Button size="lg" variant="secondary" className="rounded-full">
                <Calendar className="mr-2 h-5 w-5" />
                Schedule Your Appointment
              </Button>
            </Link> */}
          </div>
        </div>
      </section>

      {/* Emergency Banner */}
      <section className="py-8 px-0 bg-red-600 text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <Clock className="h-8 w-8" />
              <div>
                <h3 className="text-xl font-bold">24/7 Emergency Care</h3>
                <p className="text-white/90">Fully equipped emergency department </p>
              </div>
            </div>
            <a href="tel:+917399999981">
              <Button size="lg" variant="secondary" className="w-full sm:w-auto rounded-full bg-white text-red-600 hover:bg-gray-100">
                <Phone className="mr-2 h-5 w-5" />
                Call Emergency
              </Button>
            </a>
          </div>
        </div>
      </section>

    </div>
    </>
  );
}
